import { Anchor, Group } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type ThesaurusLinkProps = {
  href: string | null;
  label: string;
};

/** Lien externe ouvert dans un nouvel onglet ; rien n'est rendu si l'URL est absente. */
const ThesaurusLink = ({ href, label }: ThesaurusLinkProps) => {
  const { t } = useTranslate();

  if (!href?.trim()) return null;

  return (
    <Anchor
      href={href.trim()}
      target="_blank"
      rel="noopener noreferrer"
      size="sm"
      aria-label={t('admin.thesaurus.links.newTab', { label })}
    >
      <Group gap={4} wrap="nowrap" component="span">
        {label}
        <IconExternalLink size={14} stroke={1.5} aria-hidden />
      </Group>
    </Anchor>
  );
};

export default ThesaurusLink;
